import React from 'react';
import { classNames } from 'utils';

const TestModeIndicator = ({ withNav, badge }) => (
  <div className="layout-test-mode-indicator-container">
    {badge !== false && (
      <div
        className={classNames('layout-test-mode-indicator', {
          'with-nav': withNav,
        })}
      >
        TEST MODE
      </div>
    )}
  </div>
);

export default TestModeIndicator;
